/**
 * Bridge module: re-exports liftango-ui design tokens as simple constants.
 *
 * Use these throughout the Atlas codebase instead of MUI
 * `theme.palette.*` references. During the migration MUI's ThemeProvider
 * and sx engine remain in place, but colours/spacing should reference
 * these tokens so we can eventually remove the MUI theme.
 *
 * Usage:
 *   import { opsColors, opsElevation } from '../../theme/opsTokens';
 *   sx={{ color: opsColors.neutral.ink, boxShadow: opsElevation.drawer.shadow }}
 */
import { lightTheme } from '@liftango/ui-tokens';

export const opsColors = lightTheme.colors;
export const opsSpace = lightTheme.space;
export const opsFontSize = lightTheme.fontSize;
export const opsFontFamily = lightTheme.fontFamily;
export const opsFontWeight = lightTheme.fontWeight;
export const opsRadius = lightTheme.radius;
export const opsElevation = lightTheme.elevation;
export const opsTransition = lightTheme.transition;
export const opsZIndex = lightTheme.zIndex;
